import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { InformationCircleIcon } from "@heroicons/vue/24/outline";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import OaiTooltip from "shared/components/other/OaiTooltip.vue";
import { CriticalPathContext, CriticalPathDelta } from "shared/types/CriticalPath";
import CriticalPathDelay from "shared/views/critical_path/components/CriticalPathDelay.vue";
import CriticalPathModal from "shared/views/critical_path/components/CriticalPathModal.vue";
import { getNodeNameByTags } from "@/views/reports/plots/milestone/milestoneCriticalPath";
import { MilestonePlotGroup } from "@/views/reports/plots/milestone/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'MilestonePlotDeltaLabels',
  props: {
    criticalPathGroups: {},
    context: {},
    chartHeight: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const isCriticalPathModalOpen = ref(false);
const criticalPathModalInitialSelectedNodeId = ref<string | undefined>(undefined);

const criticalPathDelayPositionById = computed(() => {
  const totalItemsCount = props.criticalPathGroups.reduce(
    (acc, group) => acc + group.nodeDeltas.length,
    0,
  );
  const topSpacing = 35;
  const xAxisHeight = 45;
  const labelHeight = 20;
  const map: Record<string, number> = {};
  let y = topSpacing;
  const reversedCriticalPathGroups = props.criticalPathGroups.slice().reverse();
  for (const group of reversedCriticalPathGroups) {
    const height =
      (props.chartHeight - topSpacing - xAxisHeight) * (group.nodeDeltas.length / totalItemsCount);
    map[group.lastNodeId] = y + height / 2 - labelHeight / 2;
    y += height;
  }
  return map;
});

const openCriticalPathModal = (nodeId?: string) => {
  criticalPathModalInitialSelectedNodeId.value = nodeId;
  isCriticalPathModalOpen.value = true;
};

const closeCriticalPathModal = () => {
  criticalPathModalInitialSelectedNodeId.value = undefined;
  isCriticalPathModalOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criticalPathGroups.filter((group) => group.delta), (group) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.lastNodeId
      }, [
        (group.notMatchingNodeDeltas.length === 0)
          ? (_openBlock(), _createBlock(CriticalPathDelay, {
              key: 0,
              deltaForNode: group.delta as CriticalPathDelta,
              noBackgroundHighlight: true,
              cls: "absolute right-0",
              style: _normalizeStyle({
          top: `${criticalPathDelayPositionById.value[group.lastNodeId] || 0}px`,
        }),
              onClick: ($event: any) => (openCriticalPathModal(group.lastNodeId))
            }, null, 8, ["deltaForNode", "style", "onClick"]))
          : (_openBlock(), _createBlock(OaiTooltip, {
              key: 1,
              cls: "absolute right-[15px]",
              style: _normalizeStyle({
          top: `${criticalPathDelayPositionById.value[group.lastNodeId] || 0}px`,
        })
            }, {
              tooltip: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)("analytics.reports.incomplete_path_no_delta")), 1),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.notMatchingNodeDeltas.slice().reverse(), (difference) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: difference.node._id
                      }, _toDisplayString(_unref(getNodeNameByTags)(difference.node, _ctx.context)), 1))
                    }), 128))
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(InformationCircleIcon), { class: "w-6 h-6" })
              ]),
              _: 2
            }, 1032, ["style"]))
      ]))
    }), 128)),
    (isCriticalPathModalOpen.value)
      ? (_openBlock(), _createBlock(CriticalPathModal, {
          key: 0,
          onClose: closeCriticalPathModal,
          origin: "query_value_widget",
          initialSelectedNodeId: criticalPathModalInitialSelectedNodeId.value
        }, null, 8, ["initialSelectedNodeId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})